export default __webpack_public_path__ + "dim-a2f4fb.json";